module.exports = __webpack_public_path__ + "media/images/Books_Sept2018_HomePage-4ae6903862597f07d0ebf499c008219c.jpg";